import { TSpace } from '../../../Spaces/Space';

export interface IP_Floor extends TSpace {

    errSum: boolean;
    initialized: boolean;
    floorNumber: number | undefined;
    isOn: boolean;
    isMan: boolean;
}

export const schema = 'AutomationApps.Plants.Buildings.P_Floor';


 